import util from '@bmp-vue/core/api/util'
const controller = 'Tidas'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  BuscarDados: function (dto) {
    return util.Axios.Post(controller + '/BuscarDados', dto)
  },
})
